import React, { useContext } from 'react'
import { Form } from 'react-bootstrap'
import { NewTooltip } from '../common/newToolTip'
import { SettingsContext } from '../../context/settings-context'

import MoneyLight from '../../assets/images/special-category/money-light.svg'
import MoneyDark from '../../assets/images/special-category/money-dark.svg'
import BriefcaseLight from '../../assets/images/special-category/briefcase-light.svg'
import BriefcaseDark from '../../assets/images/special-category/briefcase-dark.svg'
import HomeLight from '../../assets/images/special-category/home-light.svg'
import HomeDark from '../../assets/images/special-category/home-dark.svg'
import CampaignLight from '../../assets/images/special-category/campaign-light.svg'
import CampaignDark from '../../assets/images/special-category/campaign-dark.svg'

const SpecialAdCategoryModal = ({ selectedCategories = [], onToggleCategory }) => {
    const { theme } = useContext(SettingsContext)
    const isLight = theme === 'light'
    const strokeColor = isLight ? 'rgba(206, 154, 0, 1)' : 'rgba(255, 211, 36, 1)'

    const options = [
        {
            value: 'financial',
            label: 'Financial products and services (formerly Credit)',
            description:
                'Ads for credit cards, long-term financing, current and savings accounts, investment services, insurance services or other related financial opportunities.',
            icon: isLight ? MoneyLight : MoneyDark,
        },
        {
            value: 'employment',
            label: 'Employment',
            description:
                'Ads for job offers, internships, professional certification programmes or other related opportunities.',
            icon: isLight ? BriefcaseLight : BriefcaseDark,
        },
        {
            value: 'housing',
            label: 'Housing',
            description: 'Ads for property listings, home insurance, mortgages or other related opportunities.',
            icon: isLight ? HomeLight : HomeDark,
        },
        {
            value: 'social',
            label: 'Social issues, elections or politics',
            description:
                'Ads about social issues (such as the economy, or civil and social rights), elections, or political figures or campaigns.',
            icon: isLight ? CampaignLight : CampaignDark,
        },
    ]

    return (
        <div className="app-modal px-2">
            <p className="mb-3 fw-normal d-flex align-items-center mt-3">
                Select the special ad category you are advertising
                <NewTooltip
                    placement="right"
                    text="When advertising to special ad categories, Facebook enforces certain rules on who you can target. The rules depend on the special category you are advertising to."
                    className="media-buying-tool-tip"
                >
                    <span className="ms-2">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="10" stroke="rgba(137, 156, 189, 1)" strokeWidth="1.5" />
                            <path
                                d="M12 13L12 8"
                                stroke="rgba(137, 156, 189, 1)"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                            <path
                                d="M12 16L12 15.75"
                                stroke="rgba(137, 156, 189, 1)"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                            />
                        </svg>
                    </span>
                </NewTooltip>
            </p>

            <div className="alert-box d-flex align-items-start gap-2 mb-4">
                <svg
                    style={{ marginRight: '6px', marginLeft: '-4px' }}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                >
                    <circle cx="12" cy="12" r="10" stroke={strokeColor} strokeWidth="1.5" />
                    <path d="M12 13L12 8" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" />
                    <path d="M12 16L12 15.75" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" />
                </svg>
                <span>
                    <strong>Important:</strong> If your ad falls under one of these categories but you don’t select it,
                    your ad may be rejected. Please choose the correct category to avoid delays or issues.
                </span>
            </div>

            <Form>
                {options.map((opt) => (
                    <div key={opt.value} className="mb-3">
                        <div className="d-flex align-items-start">
                            <input
                                type="checkbox"
                                id={`specialAd-${opt.value}`}
                                className="custom-checkbox mt-1"
                                checked={selectedCategories.includes(opt.value)}
                                onChange={() => onToggleCategory(opt.value)}
                            />
                            <div className="ms-3" style={{ marginTop: '1.5px' }}>
                                <label
                                    htmlFor={`specialAd-${opt.value}`}
                                    className="d-flex align-items-center fw-semibold mb-1 option-title"
                                >
                                    <img src={opt.icon} alt={opt.value} className="me-2" width={24} height={24} />
                                    {opt.label}
                                </label>

                                <div className="text-desc option-description">{opt.description}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </Form>
        </div>
    )
}

export default SpecialAdCategoryModal
